import React from 'react'
import { Button, styled } from "@mui/material"
//import { enableBrowserBack } from 'Components/DisableBrowser'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory } from '../useHistory'
import { useUser } from '../../services/StateContext'
//import { useHistory } from 'services/Context'

//import { useNavigateBack } from 'Components/useNavigateBack'
//import { useUser } from 'services/StateContext'
//import { history } from 'services/history'
//import useLocationChange from 'Components/useLocationChange'

const pathProps = {
    especialidade: {
        descricaoEspecialidade: '',
    },
    convenio: {
        descricaoConvenio: ''
    },

}

/* <Button
{...others} 
fullWidth 
variant={'contained'} 
children={'Voltar'} 
onClick={onRedirect}
sx={{
    textAlign: 'center',
    height: 60,
    width: '100%',
    cursor: 'pointer',
    overflow: 'hidden',
    color: '#fff',
    bgcolor: '#0c1141',
    '&:hover': {
        bgcolor: '#41477d'
    }  

}}

/> */

const button_bg    = process.env.REACT_APP_BUTTON_STYLE_BG
const button_hover = process.env.REACT_APP_BUTTON_STYLE_HOVER

export const ButtonBack = styled(Button)({
    textAlign: 'center',
    height: 60,
    width: '100%',
    cursor: 'pointer',
    overflow: 'hidden',
    color: '#fff',
    backgroundColor: button_bg,
    '&:hover': {
        backgroundColor: button_hover
    }  
})

const Back = (props) => {
    
    const navigate          = useNavigate()
    const { pathname }      = useLocation()
    const { historyPaths }  = useHistory()
    const { user, setUser } = useUser()

    const { loading, onClick, ...others } = props
    
    const onRedirect = () => {
        let changeProps   = null
        const paths       = [ ...historyPaths ]
        const pathIndex   = paths.findIndex( path => path === pathname)
        const replacePath = paths[pathIndex - 1]
        historyPaths.delete(pathIndex)

        if (onClick) { onClick() }
        
        if (pathname === '/dia') {
            changeProps = pathProps.especialidade
        } else if (pathname === '/especialidade' && !user.userExists) {
            changeProps = pathProps.convenio
        }
        
        changeProps && setUser( prevState => ({ ...prevState, ...changeProps }))

        navigate(replacePath, { replace: true })
    } 

    if (loading) { return null }
    
    return <>
        <ButtonBack
            {...others} 
            fullWidth 
            //variant={'contained'} 
            children={'Voltar'} 
            onClick={onRedirect}
            // sx={{
            //     textAlign: 'center',
            //     height: 60,
            //     width: '100%',
            //     cursor: 'pointer',
            //     overflow: 'hidden',
            //     color: '#fff',
            //     bgcolor: '#0c1141',
            //     '&:hover': {
            //         bgcolor: '#41477d'
            //     }  

            // }}
            
        />
    </>
}

export default Back